import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { Chart as ChartJS } from "chart.js";
import { applyChartJsDefaults } from "./theme/minimalTheme";

// Align every react-chartjs-2 surface to the minimal theme (font + calm colours)
// in one place — Chart.defaults is a shared singleton read at render time.
applyChartJsDefaults(ChartJS);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
